import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import { useAppServices } from "hook/services";
import { useAgencyInfo } from "context/agency";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
function Stripe() {
  const navigate = useNavigate();
  const { search } = useLocation();
  const [agency, update] = useAgencyInfo();
  const searchParams = new URLSearchParams(document.location.search);
  const code = new URLSearchParams(search).get("code");
  const agency_id = searchParams.get("state");
  const AppServices = useAppServices();

  const [Error, setError] = useState("");

  const updateAgency = async (creds) => {
    const payload = {
      _id: agency_id,
      stripe: {
        key: creds.access_token,
        refresh_token: creds.refresh_token,
        publish_key: creds.stripe_publishable_key,
        account_id: creds.stripe_user_id,
        access_token: creds.access_token,
      },
    };

    const { response } = await AppServices.agency.UpdateStripe({ payload });

    if (!response) return setError("Something went wrong while integration, please try latter");

    setError("Account connected successfully");
    setTimeout(() => {
      window.close()
    }, 2000);
    // response && update({ ...payload });
    // return navigate(-2);
  };

  const getCreds = async () => {
    const { response } = await AppServices.stripe.integrateAcocunt({ query: `code=${code}` });
    if (!response) return setError("Something went wrong while integration, please try latter");
    response && updateAgency(response.data);
    return "";
  };

  const onLoad = () => {
    getCreds();
  };

  useEffect(onLoad, []);

  return (
    <DashboardLayout>
      <SoftBox>
        {!Error && <SoftBox>Integrating please wait...</SoftBox>}
        {Error && (
          <SoftBox>
            {Error}
            <SoftButton onClick={() => navigate(-2)}>Go Back</SoftButton>
          </SoftBox>
        )}
      </SoftBox>
    </DashboardLayout>
  );
}

export default Stripe;
